import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { styles } from '../../style/controls/ProgressSpinner.styles';
const ProgressSpinner = () => {
    return <Spinner animation='border' variant="primary" style={styles.root} />
}

export default ProgressSpinner;